import { Pipe, PipeTransform } from '@angular/core';
import { NumberUtilitiesService } from '@utilities/number-utilities.service';
@Pipe({
  name: 'numberSuffix',
})
export class NumberSuffixPipe implements PipeTransform {
  constructor(private readonly numberUtilities: NumberUtilitiesService) {}

  public transform(value: number | string, ignoreSuffix = false): string {
    let numberValue = value;

    if (typeof numberValue === 'string') {
      numberValue = Number(value);
    }

    if (isNaN(numberValue) || numberValue === null || numberValue === undefined) {
      return '0';
    }

    return this.numberUtilities.getNumberWithSuffix(numberValue, 0, 1, ignoreSuffix);
  }
}
